/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Team } from './Team.js';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './Team.js';

/**
 * 
 * @export
 * @interface GetTeamResponse
 */
export interface GetTeamResponse {
    /**
     * 
     * @type {Team}
     * @memberof GetTeamResponse
     */
    data?: Team;
    /**
     * 
     * @type {number}
     * @memberof GetTeamResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetTeamResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetTeamResponse interface.
 */
export function instanceOfGetTeamResponse(value: object): boolean {
    return true;
}

export function GetTeamResponseFromJSON(json: any): GetTeamResponse {
    return GetTeamResponseFromJSONTyped(json, false);
}

export function GetTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TeamFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetTeamResponseToJSON(value?: GetTeamResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': TeamToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

